import React, { FC, useContext, useEffect } from 'react';

import { TableBody } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../../store';

import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { SkinsTableRow } from './Components/SkinsTableRow/SkinsTableRow';
import { useRouteInfoState } from '../../../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useEventLeaderboardsState } from '../../../../../../../player/EventLeaderboards/Context/EventLeaderboards.context';

export const SkinsTableBody: FC = () => {
  const { roundId } = useRouteInfoState();
  const { adminHoleResults } = useContext(GlobalContext);
  const { skinsResults, selectedCombination } = useAssignResultsState();

  const { selectedFlightId } = useEventLeaderboardsState();

  const {
    actions: { setSkinsResults }
  } = useAssignResultsDispatch();

  useEffect(() => {
    if (selectedCombination) {
      const {
        format: { considerFlights },
        scoreType
      } = selectedCombination;

      setSkinsResults(
        adminHoleResults,
        Number(roundId),
        scoreType,
        considerFlights,
        selectedFlightId
      );
    }
  }, [adminHoleResults, selectedCombination, roundId, selectedFlightId]);

  return (
    <TableBody className="results-table-table-body">
      {Object.keys(skinsResults).map((hole: string, index: number) => (
        <SkinsTableRow key={`SkinsTableRow-${index}`} index={index} hole={hole} />
      ))}
    </TableBody>
  );
};
